<template>
  <div>FFFFF </div>
</template>

<script>
  export default {
    name: "houseResourceIndex"
  }
</script>

<style scoped>

</style>
